/**
 * BAN の異議申し立ての欄（components/AppealsPanel.tsx・利用者（Users）の画面）の英語の文言。en.ts が `...enAppeals` で取り込む
 * （ja.appeals.ts が同じキーを全部持つことを型で強制）。2026-09-27 appeal-tools・Quality SEC-HIDE-03。
 *
 * WHY 別ファイルか: en.ts が 700 行を超えている（ファイル肥大化の防止）。
 * 書き方: 制裁の種類は BAN と一時停止だけを名前で出す（appealsLogic.ts の sanctionKindKey の WHY = 隠した機能の名前を出さない）。
 * 「受け入れる」= BAN が解ける、を必ず言う（取り返しはつくが、利用者はすぐ戻ってくる）。
 */
export const enAppeals = {
  'appeals.title': 'Ban appeals',
  'appeals.lead': 'Banned users can ask you to look at their ban again from your app ({fn}). Accept to lift the ban, or reject to keep it. Your reply is shown to the user.',
  'appeals.what': 'ban appeals',
  'appeals.none': 'No open appeals.',
  'appeals.openCount': { one: '{count} open', other: '{count} open' },
  'appeals.openCountMore': '{count}+ open',
  'appeals.col.player': 'User',
  'appeals.col.ban': 'Ban',
  'appeals.col.message': 'Their appeal',
  'appeals.col.received': 'Received',
  'appeals.yourReason': 'Your reason: {reason}',
  'appeals.kind.ban': 'Ban',
  'appeals.kind.suspension': 'Suspension',
  'appeals.kind.other': 'Other sanction',
  'appeals.accept': 'Accept and unban',
  'appeals.reject': 'Reject',
  'appeals.acceptTitle': 'Accept the appeal and lift the ban?',
  'appeals.rejectTitle': 'Reject the appeal?',
  'appeals.acceptBody': 'The ban is removed and the user can sign in again with their account. This is recorded in the activity log.',
  'appeals.rejectBody': 'The ban stays. The user cannot appeal this ban again. This is recorded in the activity log.',
  'appeals.response': 'Reply to the user',
  'appeals.responseNote': '(optional, shown to the user in your app)',
  'appeals.responsePlaceholder': 'e.g. We checked the replay and lifted the ban. Sorry about that.',
  'appeals.accepted': 'Appeal accepted. The ban was lifted.',
  'appeals.acceptedStillBanned': 'Appeal accepted. This user still has another active ban.',
  'appeals.rejected': 'Appeal rejected. The ban stays.'
} as const;
